import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';
import { v4 as uuidv4 } from 'uuid';

interface Payload {
  overlayData: any[];
}

const updateDraft = async (jsonData: Payload, overlayId: string): Promise<any> => {
  const jsonObjectId = overlayId ? overlayId : uuidv4();
  const preSignedUrlResponse = await axiosInstance.post('/api/s3/put-presigned-url', {
    format: 'video',
    uuid: jsonObjectId,
  });
  await fetch(preSignedUrlResponse.data, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(jsonData),
  });
  return jsonObjectId;
};

export const useUpdateDraft = () => {
  return useMutation((
    { payload, overlayId }: { payload: Payload; overlayId?: string }) => 
    updateDraft(payload, overlayId), { 
      onSuccess: (data) => data 
    });
};
